import { render, staticRenderFns } from "./areaCascaderPanel.vue?vue&type=template&id=222089b3&"
import script from "./areaCascaderPanel.vue?vue&type=script&lang=js&"
export * from "./areaCascaderPanel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "pc/common/areaCascaderPanel.vue"
export default component.exports